import React from 'react';
import { Link } from "react-router-dom";
import RetailLocationController from './RetailLocationController.js';
import Overview from "./Overview.js";
import DayViews from "./DayViews.js"
import GameSelector from "./components/GameSelector.js";
import HeaderNav from "./components/HeaderNav.js";
import { LinearProgress } from "@mui/material";
import "../Concession/concession.css";
import "./retail.css";
import { USE_DUMMY_RETAIL_DATA, USE_DUMMY_RETAIL_OVERVIEW } from "./dummyLiveData.js";

export const MapContext = React.createContext();
export const NavContext = React.createContext();

export default function RetailLocation() {
  return (
    <RetailLocationController>
      {({
        loading,
        data,
        games,
        zones,
        now,
        currentLocation,
        currentSeries,
        currentGame,
        currentSection,
        currentSeason,
        currentTime,
        dayType,
        selectedDate,
        showCalendar,
        peak,
        avg,
        sort,
        showAllMaps,
        isToday,
        autoFetchEnabled,
        backgroundLoading,
        regularDayCount,
        counterDataAvailable,
        pregameCount,
        gatesOpenCount,
        firstPitchCount,
        counterSensorInfoData,
        counterTrafficDataList,
        overviewTrafficDataList,
        overviewSelectedDates,
        overviewGameTitlesList,
        occupancyAutoFetchEnabled,
        occupancyAutoFetchDidComplete,
        queueTimeData,
        queueTimeDataMiniMap,
        transactionTimeData,
        transactionTimeDataMiniMap,
        zoneLabels,

        setOccupancyAutoFetchDidComplete,
        setOccupancyAutoFetchEnabled,
        setAutoFetchEnabled,
        setCurrentSection,
        setCurrentSeason,
        setDayType,
        setSelectedDate,
        setShowCalendar,
        setCurrentGame,
        setCurrentSeries,
        setCurrentTime,
        setSort,
        setShowAllMaps,
        setZoneLabels,
        refreshRegularDay,
        getCurrentMinute,
        getGatesOpenTime,
        findLabelByZoneId,
        authCtx,
        theme
      }) => (
        <>
          {authCtx.loggedIn ? (
            <div className="cx-page">
              {/* TEMPORARY: remove with dummyLiveData.js */}
              {USE_DUMMY_RETAIL_DATA && (
                <div style={{ background: '#d97706', color: '#fff', textAlign: 'center', padding: '4px', fontWeight: 600 }}>
                  Dummy data mode: schedule, occupancy, entrance, queue and transaction data are fake{USE_DUMMY_RETAIL_OVERVIEW ? ' (Overview test: every section on, 4 games picked)' : ''} (local dev only)
                </div>
              )}
              <div className="sticky-top cx-topbar">
                <div>
                  <HeaderNav
                    currentLocation={currentLocation}
                    loading={loading}
                    isToday={isToday}
                    selectedDate={selectedDate}
                    showCalendar={showCalendar}
                    setShowCalendar={setShowCalendar}
                    dayType={dayType}
                    setDayType={setDayType}
                    refreshRegularDay={refreshRegularDay}
                    setSelectedDate={setSelectedDate}
                    games={games}
                    now={now}
                  />

                  {dayType === currentLocation.dayTypes.GAME && (
                    <GameSelector
                      loading={loading}
                      currentLocation={currentLocation}
                      currentSeries={currentSeries}
                      currentGame={currentGame}
                      currentSeason={currentSeason}
                      setCurrentSeason={setCurrentSeason}
                      games={games}
                      now={now}
                      isToday={isToday}
                      setCurrentGame={setCurrentGame}
                      setCurrentSeries={setCurrentSeries}
                      setSelectedDate={setSelectedDate}
                      theme={theme}
                    />
                  )}
                </div>
                {/* Show linear progress bar when doing background refresh with occupancy auto fetch enabled */}
                {backgroundLoading && occupancyAutoFetchEnabled && (
                  <div
                  style={{position: "fixed", top: 0, left: 0, right: 0, width: "100%", zIndex: 9999 }}>
                    <LinearProgress
                      sx={{
                        backgroundColor: "rgba(2, 166, 147, 0.25)",
                        height: 8,
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "rgb(2, 166, 147)",
                        },
                      }}
                    />
                  </div>
                )}
              </div>
              {loading && !(backgroundLoading && occupancyAutoFetchEnabled) ? (
                <div className="cx-content rx-page-skel" aria-busy="true" aria-label="Loading">
                  <div className="rx-skel-tabs">
                    <div className="cx-skel" />
                    <div className="cx-skel" />
                    <div className="cx-skel" />
                  </div>
                  <div className="cx-skel rx-skel-block" style={{ height: 560 }} />
                  <div className="rx-skel-tabs">
                    <div className="cx-skel" />
                    <div className="cx-skel" />
                    <div className="cx-skel" />
                  </div>
                </div>
              ) : (
                <div className="cx-content">
                  {selectedDate && (dayType === currentLocation.dayTypes.REGULAR || dayType === currentLocation.dayTypes.GAME) ? (
                    <DayViews
                      getCurrentMinute={getCurrentMinute}
                      isToday={isToday}
                      currentSection={currentSection}
                      setCurrentSection={setCurrentSection}
                      dayType={dayType}
                      currentLocation={currentLocation}
                      data={data}
                      currentTime={currentTime}
                      setCurrentTime={setCurrentTime}
                      currentGame={currentGame}
                      peak={peak}
                      avg={avg}
                      findLabelByZoneId={findLabelByZoneId}
                      getGatesOpenTime={getGatesOpenTime}
                      selectedDate={selectedDate}
                      zones={zones}
                      currentSeries={currentSeries}
                      sort={sort}
                      setSort={setSort}
                      showAllMaps={showAllMaps}
                      setShowAllMaps={setShowAllMaps}
                      autoFetchEnabled={autoFetchEnabled}
                      setAutoFetchEnabled={setAutoFetchEnabled}
                      setOccupancyAutoFetchEnabled={setOccupancyAutoFetchEnabled}
                      occupancyAutoFetchDidComplete={occupancyAutoFetchDidComplete}
                      setOccupancyAutoFetchDidComplete={setOccupancyAutoFetchDidComplete}
                      backgroundLoading={backgroundLoading}
                      regularDayCount={regularDayCount}
                      counterDataAvailable={counterDataAvailable}
                      pregameCount={pregameCount}
                      gatesOpenCount={gatesOpenCount}
                      firstPitchCount={firstPitchCount}
                      counterSensorInfoData={counterSensorInfoData}
                      counterTrafficDataList={counterTrafficDataList}
                      overviewTrafficDataList={overviewTrafficDataList}
                      overviewGameTitlesList={overviewGameTitlesList}
                      overviewSelectedDates={overviewSelectedDates}
                      queueTimeData={queueTimeData}
                      queueTimeDataMiniMap={queueTimeDataMiniMap}
                      transactionTimeData={transactionTimeData}
                      transactionTimeDataMiniMap={transactionTimeDataMiniMap}
                      zoneLabels={zoneLabels}
                      setZoneLabels={setZoneLabels}
                    />
                  ) : (
                    <Overview
                      currentLocation={currentLocation}
                      currentTime={currentTime}
                      sort={sort}
                      games={games}
                      findLabelByZoneId={findLabelByZoneId}
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className="cx-unauthorized">
              <Link to={"/auth"}>
                Not Authorized. Please Log-In with given credentials or contact support.
              </Link>
            </div>
          )}

          {/* <OutageAlert show={showOutageAlert} onDismiss={handleDismiss} /> */}
        </>
      )}
    </RetailLocationController>
  );
}